import axios from 'axios'
import { useState } from 'react';

export const isIterableArray = array => Array.isArray(array) && !!array.length;

export const pathToLottieAnimation = '/sliders/animations/'

const storageKey = 'galaktika-articule-product-of-day-key'

const defaultInterval = 8000
export const slidersIntervals = {
    autoscroll: defaultInterval,
    innerScroll: defaultInterval / 2,
    fixedInnerScroll: defaultInterval * 0.6666,
}
export const getSelectedProduct = products => {

    if (!isIterableArray(products)) return null

    const shownProducts = localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : []

    const articules = products.map(item => item.articule)

    const articulesClered = articules.filter(function (el) {
        return el != undefined;
    });

    let filtered = articulesClered.filter(artc => shownProducts.every(product_artc => !artc.includes(product_artc)));

    const selectedArticule = filtered[0]

    if (selectedArticule) {
        // console.log('нужно добавить артикул ')
        localStorage.setItem(storageKey, JSON.stringify([...shownProducts, selectedArticule]))
        return products.filter(item => item.articule === selectedArticule)[0]
    }
    else {
        // console.log('нужно добавить только артикул первого товара ')
        localStorage.setItem(storageKey, JSON.stringify([products[0].articule]))
        return products[0]
    }

}

export const isNotNullText = (text) => {
    if (!text) return false
    const cleared = text
        .replaceAll('br', '')
        .replaceAll('<', '')
        .replaceAll('>', '')
        .replaceAll('/', '')
        .replaceAll(' ', '')

    return cleared.length > 0
}

export function getBrowserName() {
    const userAgent = navigator.userAgent;

    return userAgent
    if (userAgent.indexOf("Firefox") > -1) {
        return "Firefox";
    } else if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1) {
        return "Chrome";
    } else if (userAgent.indexOf("Edg") > -1) {
        return "Edge";
    } else if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
    } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
        return "Opera";
    } else if (userAgent.indexOf("Trident") > -1) {
        return "IE";
    } else {
        return "Other";
    }
}

const getIp = async () => {
    const res = await axios.get("https://api.ipify.org?format=json")
    return res.data.ip
    // return '0'
}
export const useClientInfo = () => {
    const [clientInfo, setClientInfo] = useState(null)
    // const [loading, setLoading] = useState(false)

    const fetchClientInfo = async () => {
        // setLoading(true)
        const ip = await getIp()
        const browser = getBrowserName()
        const page_slug = window.location.href
        // const page_name = document.title

        const info = { ip, browser, app: false, page_slug }
        setClientInfo(info)
        // setLoading(false)
        return info
    }

    return { clientInfo, fetchClientInfo }
}


export const fetchBlackList = async (type) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_BASE}/pages/get-black-emails`
        );
        // console.log(response.data)
        const item = response?.data?.find(item => item.type === type);
        return item || null
    } catch (err) {
        return null
    }
}

// true если ошибка
export const checkList = (listData, value) => {
    // if (!value) return true
    // console.log(listData, !isIterableArray(listData?.list))
    // if (!listData?.active) return false
    if (!isIterableArray(listData?.list)) return false
    return listData.list.some(item => {
        // console.log(item, value, value.includes(item))
        return value.includes(item)
    })
}